import { FunctionComponent, SVGProps } from 'react';

import GoogleIcon from '@/assets/icons/google.svg?react';
import MicrosoftIcon from '@/assets/icons/microsoft.svg?react';

export type OAuthProvider = 'google' | 'microsoft';

export type OAuthProviderStrategy = 'oauth_google' | 'oauth_microsoft';

interface OAuthProviderConfig {
  strategy: OAuthProviderStrategy;
  /** Short display name, e.g. in the profile's sign-in methods list. */
  name: string;
  /** Button copy on the auth screens. */
  label: string;
  Icon: FunctionComponent<SVGProps<SVGSVGElement>>;
}

export const OAUTH_PROVIDERS: Record<OAuthProvider, OAuthProviderConfig> = {
  google: {
    strategy: 'oauth_google',
    name: 'Google',
    label: 'Continue with Google',
    Icon: GoogleIcon,
  },
  microsoft: {
    strategy: 'oauth_microsoft',
    name: 'Microsoft',
    label: 'Continue with Microsoft',
    Icon: MicrosoftIcon,
  },
};

/** Order the buttons appear in on every auth screen. */
export const OAUTH_PROVIDER_ORDER: OAuthProvider[] = ['google', 'microsoft'];
